import {IconNames} from '@blueprintjs/icons';

import {Entity} from './types';
import {ENTITY_TYPE} from './constants';

export const getEntityType = (entity: Entity) => {
  if (entity.hasOwnProperty('database_name')) {
    return ENTITY_TYPE.DATABASE;
  } else {
    return ENTITY_TYPE.INTEGRATION;
  }
}

export const getEntityName = (entity: Entity): string => {
  if (getEntityType(entity) === ENTITY_TYPE.DATABASE) {
    return `Share ${(entity as any).database_name} database`;
  } else if (getEntityType(entity) === ENTITY_TYPE.INTEGRATION) {
    return `Share ${(entity as any).name} integration`;
  }
  return 'Sharing Settings';
}

export const getEntityIcon = (entity: Entity): any => {
  if (getEntityType(entity) === ENTITY_TYPE.DATABASE) {
    return IconNames.DATABASE;
  } else if (getEntityType(entity) === ENTITY_TYPE.INTEGRATION) {
    return IconNames.WRENCH;
  }
  return undefined;
}

export const getPermission = (sharingSettings: any): 'edit' | 'view' | 'use' | '' => {
  if (!sharingSettings) {
    return '';
  }
  if (sharingSettings.edit) {
    return 'edit';
  } else if (sharingSettings.use) {
    return 'use';
  } else {
    return 'view';
  }
}
